import { Snackbar, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { useEffect, useState } from 'react';
import MuiAlert from '@mui/material/Alert';
import { fromLocalStorage, toLocalStorage } from '../../util/storage';

const STORAGE_KEY = 'slicedHealth-acknowledgedVersion';

const useStyles = makeStyles(theme => ({
    button: {
        textDecoration: 'underline',
        color: '#2739c1',
        cursor: 'pointer',
        marginLeft: '3px',
        marginRight: '3px',
    },
    alert: {
        '& .MuiAlert-message': {
            display: 'flex',
            alignItems: 'center'
        },
        backgroundColor: '#EBFFF5'
    }
}));

function ReleaseSnackbar(props) {
    const { release } = props;
    const classes = useStyles();

    const [isSnackOpen, setSnackOpen] = useState(false);

    useEffect(() => {
        if (!release?.version || typeof release.version !== 'string') return;

        const backendVersion = release?.version?.split('.').slice(0, 3).join('.');
        const acknowledgedVersion = fromLocalStorage(STORAGE_KEY);

        if (!acknowledgedVersion) {
            toLocalStorage(STORAGE_KEY, backendVersion);
            return;
        }

        if (backendVersion !== acknowledgedVersion) {
            setSnackOpen(true);
        }
    }, [release]);

    const handleRefresh = () => {
        if (release?.version) {
            const backendVersion = release.version.split('.').slice(0, 3).join('.');
            toLocalStorage(STORAGE_KEY, backendVersion);
        }

        if ('caches' in window) {
            caches.keys().then((names) => {
                // Delete all the cache files
                names.forEach(name => {
                    caches.delete(name);
                })
            });
        }
        window.location.reload();
    };

    const handleClose = () => {
        setSnackOpen(false);
    };

    return (
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={isSnackOpen}
            onClose={handleClose}
            key={'topcenter'}
        >
            <MuiAlert
                elevation={6}
                className={classes.alert}
                icon={false}
                onClose={handleClose}
                severity="info"
            >
                A new version of the app is detected.
                <Typography className={classes.button} onClick={handleRefresh}>
                    Click here
                </Typography>
                to reload.
            </MuiAlert>
        </Snackbar>
    );
}

export default ReleaseSnackbar;